import { computed } from 'vue'
import { useMe } from './swr/useMe'

export const useUserRoles = () => {
  const { data: currentUser } = useMe()

  const hasRole = (role: string) =>
    currentUser.value?.roles.includes(role) ?? false

  const isSuperadmin = computed(() => hasRole('superadmin'))
  const isAdmin = computed(() => hasRole('admin'))
  const isManager = computed(() => hasRole('manager'))
  const isLearningManager = computed(() => hasRole('learning_manager'))
  const isSuperuser = computed(() => hasRole('superuser'))
  const isSupervisor = computed(() => hasRole('supervisor'))
  const isUser = computed(() => hasRole('user'))

  const isAtLeastSuperuser = computed(
    () => isSuperadmin.value || isSuperuser.value || isAdmin.value
  )

  return {
    hasRole,
    isSuperadmin,
    isAdmin,
    isManager,
    isLearningManager,
    isSuperuser,
    isSupervisor,
    isUser,
    isAtLeastSuperuser,
  }
}
